import Tooltip from 'rc-tooltip'
import 'styles/Tooltip.css'

export default Tooltip
